import { render } from "./index.vue?vue&type=template&id=5ec9d212&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=5ec9d212&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5ec9d212"

export default script